import "./lib/sentry"
import "./lib/posthog"
import React from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import QrBuilder from "./components/QrBuilder"
import { setupHamburger } from "./lib/hamburger"
import { setupFlash } from "./lib/flash"
import { setupPricingToggle } from "./lib/pricing-toggle"
import { setupFaqFilter } from "./lib/faq-filter"
import { setupTools } from "./lib/tools"
import { setupEmbedResize } from "./lib/embed"
import { setupEmbedSnippet } from "./lib/embed-snippet"

document.addEventListener("DOMContentLoaded", () => {
  // Marketing pages (server-rendered ERB) ship the hamburger menu, the
  // pricing-page monthly/annual toggle, the FAQ typeahead filter, and the
  // free /tools/ widgets (each a no-op when its element isn't present).
  setupHamburger()
  setupFlash()
  setupPricingToggle()
  setupFaqFilter()
  setupTools()
  // The embeddable tool surface posts its height to the parent frame; the
  // /tools/<slug> pages get a copy-to-clipboard button on the embed snippet.
  // Both no-op when their elements aren't on the page.
  setupEmbedResize()
  setupEmbedSnippet()

  // The dashboard SPA.
  const appRoot = document.getElementById("react-root")
  if (appRoot) {
    createRoot(appRoot).render(<App />)
  }

  // The live QR builder, mounted as an island into the marketing landing page.
  const builderRoot = document.getElementById("qr-builder")
  if (builderRoot) {
    // The hero grid reflows by CSS off a data-attribute: builder + copy side by
    // side when idle, builder full width with the copy as a band beneath once a
    // code is live. QrBuilder owns its state; it just broadcasts idle/live here.
    const heroGrid = document.getElementById("qr-hero-grid")
    // Server-rendered per request (EmailGate.required_for?(current_user)), so a
    // signed-in visitor on the marketing page never sees the email field and
    // the flag can flip without a deploy. QrBuilder still recovers if this is
    // ever stale — the server is the actual gate.
    //
    // data-placeholder / data-caption put the page's own job into the builder
    // (a listing link on the real-estate pages, #340). Absent, they read as
    // undefined and the builder keeps its defaults.
    createRoot(builderRoot).render(
      <QrBuilder
        requireEmail={builderRoot.dataset.requireEmail === "true"}
        destinationPlaceholder={builderRoot.dataset.placeholder || undefined}
        caption={builderRoot.dataset.caption || undefined}
        // Hosted contact pages (#332): the global flag, absent while off.
        contactPages={builderRoot.dataset.contactPages === "true"}
        onStateChange={(state) => {
          if (heroGrid) heroGrid.dataset.builderState = state
        }}
      />
    )
  }
})
